import { render, staticRenderFns } from "./QuartiersentwicklungProcessSteps.vue?vue&type=template&id=8e8f98de&scoped=true&"
import script from "./QuartiersentwicklungProcessSteps.vue?vue&type=script&lang=js&"
export * from "./QuartiersentwicklungProcessSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8f98de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VSheet})
